/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Private_Chats_Update_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not change who sees chats in this project." |
*
* @param {Project_Private_Chats_Update_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_private_chats_update_error = /** @type {((inputs?: Project_Private_Chats_Update_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Private_Chats_Update_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Sichtbarkeit der Chats in diesem Projekt konnte nicht geändert werden.")
	return /** @type {LocalizedString} */ ("Could not change who sees chats in this project.")
});